import angular from 'angular';
import uiRouter from 'angular-ui-router';
import workTeamListComponent from './workTeamList.component';

let workTeamListModule = angular.module('workTeamList', [
  uiRouter
])

.component('workTeamList', workTeamListComponent)

.name;

export default workTeamListModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/workTeamList/workTeamList.js